import { ColorMode, SystemStatus } from '@anschuetz-elog/common';
import { vuetify } from '@anschuetz-elog/frontend-core';
import Vue from 'vue';

import store from '@/store';

let lastColorMode: ColorMode | null = null;
function updateColorMode(systemStatus: SystemStatus | null): void {
  if (!systemStatus || systemStatus.colorMode === lastColorMode) {
    return;
  }
  lastColorMode = systemStatus.colorMode;
  if (systemStatus.colorMode === ColorMode.Day) {
    vuetify.framework.theme.dark = false;
  } else if (systemStatus.colorMode === ColorMode.Night) {
    vuetify.framework.theme.dark = true;
  }
}

export function load(): void {
  Vue.use((): void => {
    // check after each reconnect
    store.original.watch(
      (state) => {
        return state.systemStatus.systemStatus;
      },
      (systemStatus) => {
        updateColorMode(systemStatus);
      },
    );
  });
}
